module.exports = __webpack_public_path__ + "static/media/12.de711969.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/12.png
// module id = 971
// module chunks = 0